import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "header-label-group" }
const _hoisted_3 = {
  key: 1,
  class: "header-label"
}
const _hoisted_4 = {
  key: 0,
  class: "sortIcons"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!

  return (_ctx.header.label != "idMasquee")
    ? (_openBlock(), _createElementBlock("th", {
        key: 0,
        id: `th-${_ctx.header.sortData || _ctx.header.label}`,
        scope: "col",
        class: _normalizeClass(_ctx.header.sortStatus !== _ctx.SortType.INACTIVE ? 'pointer' : ''),
        style: _normalizeStyle(_ctx.getHeaderStyle(_ctx.header))
      }, [
        (_ctx.header.sortData === 'uniqueDocumentId')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "th-wrapper",
              style: _normalizeStyle(_ctx.getDivHeaderStyle(_ctx.header))
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("span", null, null, -1)
            ]))], 4))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["th-wrapper", _ctx.header.sortStatus !== _ctx.SortType.INACTIVE ? 'pointer' : '']),
              style: _normalizeStyle(_ctx.getDivHeaderStyle(_ctx.header))
            }, [
              _createElementVNode("span", _hoisted_2, [
                (_ctx.header.sortStatus !== _ctx.SortType.INACTIVE)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetSort(_ctx.header))),
                      class: "header-label btn-sort"
                    }, _toDisplayString(_ctx.$t(_ctx.header.label)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.header.label)), 1)),
                (_ctx.header.regleCle)
                  ? (_openBlock(), _createBlock(_component_ReglePastille, {
                      key: 2,
                      cle: _ctx.header.regleCle,
                      placement: "auto"
                    }, null, 8, ["cle"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.header.sortStatus !== _ctx.SortType.INACTIVE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-sort-icon",
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.setSortAsc(_ctx.header)), ["stop"])),
                      "aria-label": _ctx.$t('aria.tri.ascendant')
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.sortUpIcon,
                        alt: "",
                        "aria-hidden": "true",
                        class: _normalizeClass({'active': _ctx.header.sortStatus === _ctx.SortType.ASC})
                      }, null, 10, _hoisted_6)
                    ], 8, _hoisted_5),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn-sort-icon",
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.setSortDesc(_ctx.header)), ["stop"])),
                      "aria-label": _ctx.$t('aria.tri.descendant')
                    }, [
                      _createElementVNode("img", {
                        src: _ctx.sortDownIcon,
                        alt: "",
                        "aria-hidden": "true",
                        class: _normalizeClass({'active': _ctx.header.sortStatus === _ctx.SortType.DESC})
                      }, null, 10, _hoisted_8)
                    ], 8, _hoisted_7)
                  ]))
                : _createCommentVNode("", true)
            ], 6))
      ], 14, _hoisted_1))
    : _createCommentVNode("", true)
}